import { createFileRoute } from "@tanstack/react-router"
import { ContractDetailsPage } from "./-components/ContractDetailsPage"

export const Route = createFileRoute("/app/contracts/contracts/$id")({
  component: RouteComponent,
})

function RouteComponent() {
  const contractId = Route.useParams({
    select: (params) => parseInt(params.id),
  })
  return <ContractDetailsPage contractId={contractId} />
}
